export default function StatsSection() {
  const stats = [
    { value: '50,000+', label: '漫画资源', icon: 'ri-book-open-line' },
    { value: '1,200万+', label: '月活跃用户', icon: 'ri-user-star-line' },
    { value: '99.9%', label: '服务可用率', icon: 'ri-shield-check-line' },
    { value: '8大分类', label: '满足所有口味', icon: 'ri-grid-line' },
  ]

  return (
    <section className="py-12 md:py-16 bg-foreground-900">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-background-50/10 flex items-center justify-center">
                <i className={`${stat.icon} text-background-50/80 text-xl`}></i>
              </div>
              <p className="text-2xl md:text-3xl font-heading text-background-50 mb-1">{stat.value}</p>
              <p className="text-xs text-background-400">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}